export const MAIN_MARKET_ID = -1;
export const MAIN_MARKET_NAME = 'main market (not available)';
export const MAIN_MARKET_CHOOSE_OPTION = 'choose option';
